import { Link, useLocation } from 'react-router-dom';
import { routePaths } from '@/routes/paths';
import { useAuth } from '@/shared/hooks/useAuth';
import type { UserProfile } from '@/types/user';

type LocationState = {
  message?: string | null;
  profile?: UserProfile | null;
};

export function AccessPendingPage() {
  const { signOut, profileError, profile: ctxProfile, refreshProfile } = useAuth();
  const location = useLocation();
  const state = location.state as LocationState | null;
  const profile = state?.profile ?? ctxProfile;

  const isPendingRole = profile?.role === 'pending';
  const isInactive = profile?.active === false && !isPendingRole;

  return (
    <div className="auth-screen">
      <div className="auth-card auth-card--wide">
        <h1>{isInactive ? 'Cuenta desactivada' : 'Acceso pendiente'}</h1>

        {profile?.photoURL ? (
          <img
            src={profile.photoURL}
            alt=""
            className="auth-avatar"
            width={64}
            height={64}
          />
        ) : null}

        {profile ? (
          <p className="auth-muted">
            <strong>{profile.displayName}</strong>
            <br />
            {profile.email}
          </p>
        ) : null}

        <p className="auth-muted">
          {state?.message ??
            profileError ??
            (isInactive
              ? 'Tu cuenta fue desactivada. Contactá al administrador para rehabilitar el acceso.'
              : isPendingRole
                ? 'Tu cuenta fue registrada. Un superadmin debe aprobar tu acceso y asignarte un rol.'
                : 'No tenés perfil en el sistema. Contactá al superadmin.')}
        </p>

        {isPendingRole ? (
          <p className="auth-muted">
            Estado: <strong>Pendiente de aprobación</strong>. Cuando te activen,
            recargá esta página o volvé a iniciar sesión.
          </p>
        ) : isInactive ? (
          <p className="auth-muted">
            Estado: <strong>Inactivo</strong>. No podés acceder a módulos
            operativos hasta que un administrador reactive tu cuenta.
          </p>
        ) : (
          <p className="auth-muted">
            El superadmin puede gestionar usuarios en{' '}
            <code>/admin/usuarios</code>.
          </p>
        )}

        <div className="inventory-actions">
          <button
            type="button"
            className="auth-button auth-button--secondary"
            onClick={() => void refreshProfile()}
          >
            Revisar de nuevo
          </button>
          <button
            type="button"
            className="auth-button auth-button--secondary"
            onClick={() => void signOut()}
          >
            Cerrar sesión
          </button>
        </div>
        <p>
          <Link to={routePaths.login}>Volver al login</Link>
        </p>
      </div>
    </div>
  );
}
